/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Row,
  Col,
  Space,
  Descriptions,
  Table,
  Collapse,
  Tabs,
  Steps,
  Button,
} from "antd";

import {
  ArrowLeftOutlined,
  CopyOutlined,
  EditOutlined,
  PrinterOutlined,
} from "@ant-design/icons";

// import SamplePreparationService from "../../service/SamplePreparation.service.js";
import ProductSpecificationService from "../../service/ProductSpecification.service";
import { capitalized } from "../../utils/util.js";
import {
  parameterColumnView,
  parameterCustomerColumnView,
  parameterMicroColumnView,
  parameterMetalColumnView
} from "./model.js";

import dayjs from "dayjs";

const pspService = ProductSpecificationService();

export default function ProductSpecificationView() {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const mngConfig = {
    title: "",
    textOk: null,
    textCancel: null,
    action: "create",
    code: null,
    version: 1,
  };

  const [masters, setMasters] = useState({});
  const [verNo, setVerNo] = useState(1);

  const defaultPanes = useMemo(
    () =>
      Array.from({ length: verNo }).map((_, index) => ({
        label: `Version ${verNo - 1 - index}`,
        key: verNo - 1 - index,
      })),
    [verNo]
  );

  const [version, setVersion] = useState(defaultPanes);

  const [activeKey, setActiveKey] = useState(defaultPanes[0].key);

  const [versionData, setVersionData] = useState([]);

  const [psyItems, setPsyItems] = useState([]);
  const [customer_para, setCustomer_para] = useState([]);
  const [micro_para, setMicro_para] = useState([]);
  const [metal_para, setMetal_para] = useState([]);
  const [parametersTreatment, setParametersTreatment] = useState([]);

  const onChangeTab = (key) => {
    setActiveKey(key);
    // console.log(versionData[key]);

    setMasters(versionData[key]);
    setCustomer_para(versionData[key].customer_para);
    setPsyItems(versionData[key].phy_para);
    setMicro_para(versionData[key].micro_para);
    setMetal_para(versionData[key].metal_para);
    setParametersTreatment(versionData[key].treatment_process);
  };

  const gettingPSPData = () => {
    pspService.get(config?.code).then(async (res) => {
      const { result } = res.data;

      setMasters(result[result.length - 1]);
      setCustomer_para(result[result.length - 1].customer_para);
      setPsyItems(result[result.length - 1].phy_para);
      setMicro_para(result[result.length - 1].micro_para);
      setMetal_para(result[result.length - 1].metal_para);

      setParametersTreatment(result[result.length - 1].treatment_process);

      // console.log(result[result.length - 1].micro_para);

      setVersionData({ ...result });
      setVerNo(result.length);
      setActiveKey(result.length - 1);
    });
  };

  const hendleClose = () => {
    navigate("/product-specification", { replace: true });
  };

  const handleDuplicateProductSpecification = () => {
    // alert(version.length);
    navigate("/product-specification/manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Duplicate Product",
          action: "copy",
          code: versionData[activeKey],
          version: version.length,
        },
      },
    });
  };

  const handleEditProductSpecification = () => {
    // alert(activeKey);
    navigate("/product-specification/manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Edit Product",
          action: "edit",
          code: versionData[activeKey],
          version: activeKey,
        },
      },
    });
  }

  const handlePrint = () => {
    const targetUrl = `/psp-print/${config?.code}/${activeKey}`;
    const newWindow = window.open(targetUrl, "_blank", "noopener,noreferrer");

    // Fallback when popup is blocked by browser policy.
    if (!newWindow) {
      window.location.assign(targetUrl);
    }
  };

  useEffect(() => {
    setVersion(defaultPanes);
  }, [defaultPanes]);

  useEffect(() => {
    // console.log(config);
    if (!config) {
      hendleClose();
      return;
    }
    gettingPSPData();

    return () => {};
  }, []);

  const splitSteps = (steps, perRow = 3) => {
    const rows = [];
    for (let i = 0; i < steps.length; i += perRow) {
      rows.push(steps.slice(i, i + perRow));
    }
    return rows;
  };

  const masterItems = [
    {
      label: "PSP Code",
      children: masters?.psp_code,
    },
    {
      label: "PSP Date",
      children: dayjs(masters?.psp_date).format("DD/MM/YYYY"),
    },
    {
      label: "SP Status",
      // children: capitalized(masters?.sp_status),
      children: !!masters?.sp_status
        ? `${capitalized(
            masters?.sp_status || ""
          )}`
        : "",
    },
    {
      label: "Product Name",
      children: masters?.spname,
      span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
    },
    { label: "Product Code", children: masters?.product_code },
    { label: "Sample Code", children: masters?.spcode },
    {
      label: "Packaging type/size",
      children: masters?.pkname,
    },
    {
      label: "Product Description",
      children: masters?.product_description,
    },
    {
      label: "Ingredients",
      children: masters?.ingredients,
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "Allergen information",
      children: masters?.allergenic_info,
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "Allergenic",
      children: masters?.allergenic,
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "Remark",
      labelStyle: { verticalAlign: "top" },
      children: (
        <>
          <pre>{masters.remark}</pre>
        </>
      ),
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
  ];

  const remarkItems = [
    {
      label: "Remark for Print",
      labelStyle: { verticalAlign: "top" },
      children: (
        <>
          <pre>{masters.remark_print}</pre>
        </>
      ),
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
  ];


  const masterbottoms = [
    {
      label: "Micro Description",
      children: masters.micro_description,
      labelStyle: { verticalAlign: "top" },
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "Metal Description",
      children: masters.metal_description,
      labelStyle: { verticalAlign: "top" },
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "Storage Conditions",
      children: masters.storage_conditions,
      labelStyle: { verticalAlign: "top" },
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "Shelf Life",
      children: !!masters?.shelf_life
        ? `${masters?.shelf_life} ${capitalized(
            masters?.shelf_life_unit || ""
          )}s`
        : "",
      span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
    },
    {
      label: "Halal Status",
      children: masters.halal_status,
      labelStyle: { verticalAlign: "top" },
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "GMO Status",
      children: masters.gmo_status,
      labelStyle: { verticalAlign: "top" },
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "Create Date",
      children: !!masters?.created_date
        ? dayjs(masters?.created_date).format("DD/MM/YYYY")
        : "",
      span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
    },
    {
      label: "Create By",
      children: masters.created_name,
    },
  ];
  const customerItems = [
    {
      key: "1",
      label: "Customer List",
      children: (
        <Table
          style={{ backgroundColor: "#fafafa" }}
          dataSource={customer_para}
          columns={parameterCustomerColumnView}
          pagination={false}
          rowKey="seq"
          scroll={{ x: "max-content" }}
          size="small"
        />
      ),
      disabled: true,
      showArrow: false,
    },
  ];

  const physicalItems = [
    {
      key: "1",
      label: "Physical & Chemical Specification",
      children: (
        <Table
          style={{ backgroundColor: "#fafafa" }}
          dataSource={psyItems}
          columns={parameterColumnView}
          pagination={false}
          rowKey="seq"
          scroll={{ x: "max-content" }}
          size="small"
        />
      ),
      disabled: true,
      showArrow: false,
    },
  ];
  const microItems = [
    {
      key: "1",
      label: "Microbiological Specification",
      children: (
        <Table
          style={{ backgroundColor: "#fafafa" }}
          dataSource={micro_para}
          columns={parameterMicroColumnView}
          pagination={false}
          rowKey="seq"
          scroll={{ x: "max-content" }}
          size="small"
        />
      ),
      disabled: true,
      showArrow: false,
    },
  ];
  const heavyItems = [
    {
      key: "1",
      label: "Heavy Metal Specification", 
      children: (
        <Table
          style={{ backgroundColor: "#fafafa" }}
          dataSource={metal_para}
          columns={parameterMetalColumnView}
          pagination={false}
          rowKey="seq"
          scroll={{ x: "max-content" }}
          size="small"
        />
      ),
      disabled: true,
      showArrow: false,
    },
  ];

  const metalItems = [
    {
      key: "1",
      label: "Heavy Metal Specification",
      children: (
        <Table
          style={{ backgroundColor: "#fafafa" }}
          dataSource={metal_para}
          columns={parameterMetalColumnView}
          pagination={false}
          rowKey="seq"
          scroll={{ x: "max-content" }}
          size="small"
        />
      ),
      disabled: true,
      showArrow: false,
    },
  ];

  const treatmentItems = [
    {
      key: "1",
      label: "Treatment & Processing",
      children: (
        <div>
          {(() => {
            // สร้าง array ของ step object พร้อมเลขในวงกลม (CSS)
            const stepsWithCircle = parametersTreatment.map((item, idx) => ({
              ...item,
              icon: (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    background: "#1890ff",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 12,
                    border: "2px solid #1890ff",
                    boxSizing: "border-box",
                  }}
                >
                  {idx + 1}
                </span>
              ),
              title: item.title,
            }));
            // แบ่งเป็นแถวละ 5
            return splitSteps(stepsWithCircle, 5).map((row, idx) => (
              <Steps
                key={idx}
                type="navigation"
                size="small"
                current={-1}
                className="site-navigation-steps"
                items={row}
                style={{ marginBottom: 16 }}
              />
            ));
          })()}
        </div>
      ),
      disabled: true,
      showArrow: false,
    },
  ];

  /** settimg child component */
  const ButtonActionSrDetailLeft = (
    <Space
      gap="small"
      align="center"
      style={{ display: "flex", justifyContent: "start" }}
    >
      <Button
        style={{ width: 120 }}
        icon={<ArrowLeftOutlined />}
        onClick={() => {
          hendleClose();
        }}
      >
        กลับ
      </Button>
    </Space>
  );

  const ButtonActionSrDetailRight = (
    <>
      <Space
        gap="small"
        align="center"
        className="flex justify-start lg:justify-end md:justify-end"
      >
        <div style={{ display: "flex", gap: ".78rem", flexWrap: "wrap" }}>
          <Button
            type="primary"
            icon={<CopyOutlined />}
            onClick={handleDuplicateProductSpecification}
          >
            Duplicate Product Specification
          </Button>
        </div>
         <div style={{ display: "flex", gap: ".78rem", flexWrap: "wrap" }}>
           <Button
            style={{
              borderColor: "#52c41a",
              color: "#fff",
              background: "#52c41a",
            }}
            icon={<EditOutlined />}
            onClick={handleEditProductSpecification}
          >
            Edit Product Specification
          </Button>
        </div>
        <div style={{ display: "flex", gap: ".78rem", flexWrap: "wrap" }}>
          <Button
            style={{
              borderColor: "#faad14", // สี warning ของ Antd
              color: "#fff",
              background: "#faad14",
            }}
            icon={<PrinterOutlined />}
            onClick={handlePrint}
          >
            Print Product Specification
          </Button>
        </div>
      </Space>
    </>
  );

  // console.log('Current count:', detailItemsActive);
  return (
    <>
      <Space
        direction="vertical"
        size="middle"
        style={{
          display: "flex",
          position: "relative",
          paddingInline: "1.34rem",
        }}
        className="sample-preparation-view"
      >
        <Row
          gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
          className="m-0"
        >
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailLeft}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailRight}
          </Col>
        </Row>

        <Tabs
          hideAdd
          onChange={onChangeTab}
          activeKey={activeKey}
          type="card"
          // onEdit={onEdit}
          items={version}
        />

        <Descriptions
          bordered
          column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
          items={masterItems}
        />

        <Collapse
          size="large"
          className="view-collapse-sp"
          collapsible="disabled"
          activeKey={"1"}
          bordered={false}
          style={{ backgroundColor: "transparent" }}
          items={customerItems}
        />

        <Collapse
          size="large"
          className="view-collapse-sp"
          collapsible="disabled"
          activeKey={"1"}
          bordered={false}
          style={{ backgroundColor: "transparent" }}
          items={physicalItems}
        />

        <Collapse
          size="large"
          className="view-collapse-sp"
          collapsible="disabled"
          activeKey={"1"}
          bordered={false}
          style={{ backgroundColor: "transparent" }}
          items={microItems}
        />

        <Collapse
          size="large"
          className="view-collapse-sp"
          collapsible="disabled"
          activeKey={"1"}
          bordered={false}
          style={{ backgroundColor: "transparent" }}
          items={heavyItems}
        />

        <Descriptions
          bordered
          column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
          items={masterbottoms}
        />
        <Collapse
          size="large"
          className="view-collapse-sp"
          collapsible="disabled"
          activeKey={"1"}
          bordered={false}
          style={{ backgroundColor: "transparent" }}
          items={metalItems}
        />
        <Collapse
          size="large"
          className="view-collapse-sp"
          collapsible="disabled"
          activeKey={"1"}
          bordered={false}
          style={{ backgroundColor: "transparent" }}
          items={treatmentItems}
        />

        
        <Descriptions
          bordered
          column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
          items={remarkItems}
        />

        <Row
          gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
          className="mx-0 mb-4"
        >
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailLeft}
          </Col>
        </Row>
      </Space>
    </>
  );
}
